import React, { useState } from 'react';
import { Navbar } from '../molecules/Navbar';
import { Sidebar } from '../molecules/Sidebar';
import Content from '../../Content';

function Root() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <>
      <Navbar
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={() => setIsSidebarOpen((isOpen) => !isOpen)}
      />
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <Content />
    </>
  );
}

export default Root;
